import Talk from "talkjs";
import { mapGetters } from "vuex";
import { dialogHelper } from "@/components/mixin/dialogHelper";
import userStatusHelper from "../../mixin/userStatusHelper";

export default {
  mixins: [dialogHelper, userStatusHelper],
  props: ["me", "other", "btnClass", "hideName"],
  data() {
    return {
      modal: false,
      message: "",
      messageLoading: false,
      messageSent: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "userState",
    }),
  },
  methods: {
    handleBtnClick,
    closePopUp,
    submitMessage,
    createTalkJSConversation,
  },
};
function handleBtnClick() {
  if ((this.isRetailerSuspended || !this.isRetailerApproved) && this.user.role === "RETAILER") {
    this.showMessageWarningToSuspendedOrDeclinedRetailers();
    return;
  }

  this.modal = !this.modal;
}
function closePopUp() {
  if (this.messageLoading) {
    return;
  }
  this.modal = !this.modal;
  this.message = "";
  this.messageLoading = false;
  this.messageSent = false;
  this.$validator.reset();
}
async function submitMessage() {
  if (!(await this.$validator.validate())) {
    return;
  }
  this.messageLoading = true;
  await Talk.ready;
  this.createTalkJSConversation();
}
async function createTalkJSConversation() {
  const me = new Talk.User({
      id: this.me.userId,
      name: this.me.fullName,
      email: this.me.email,
      role: this.me.role,
    }),
    other = new Talk.User({
      id: this.other.userId,
      name: `${this.other.firstName} from ${this.other.storeName ? this.other.storeName : this.other.brand_name}`,
      email: this.other.email,
      role: this.other.role,
    }),
    popUptalkSession = new Talk.Session({
      appId: this.$utils.constants.TALKJS_APP_ID,
      me: me,
    }),
    conversation = talkSession.getOrCreateConversation(Talk.oneOnOneId(me, other));
  conversation.setParticipant(me);
  conversation.setParticipant(other);
  // eslint-disable-next-line one-var
  const popup = await talkSession.createPopup(conversation, {
    keepOpen: false,
  });
  await popup.mount({
    show: false,
  });
  await conversation.sendMessage(this.message);
  this.messageLoading = false;
  this.messageSent = true;
  popUptalkSession.destroy();

  this.closePopUp();

  this.$notify.$emit("fire", {
    message: "Message successfully sent",
    redirection: "/dashboard/messages",
    type: "success-top-center text-center",
    fadeTime: 5000,
  });
}
